export default __webpack_public_path__ + "static/media/01_s.3862379a.png";